// CSP keeps parent-installed event listeners working in WebKit, unlike a sandbox without allow-scripts (webkit.org/b/218086).
const BLOCK_SCRIPTS_POLICY =
  "script-src 'none'; object-src 'none'; frame-src 'none'; base-uri 'none'; form-action 'none'";
const PREVIEW_POLICY_ATTRIBUTE = "data-ht-email-preview-policy";
export const BLOCK_SCRIPTS_META = `<meta ${PREVIEW_POLICY_ATTRIBUTE}="" http-equiv="Content-Security-Policy" content="${BLOCK_SCRIPTS_POLICY}">`;

// Parse the policy before any email markup, but preserve the original doctype and quirks mode without reserializing the source.
export function injectBlockScriptsMeta(html: string): string {
  // Only the parser's five whitespace characters and actual comment endings may precede a doctype.
  // Accepting more lets markup open the body, or hide a script, ahead of the policy.
  const doctype = html.match(
    /^(?:[\t\n\f\r ]|<!---?>|<!--(?!-?>)(?:(?!--!?>)[\s\S])*--!?>)*<!doctype[^>]*>/i,
  );
  const end = doctype?.[0].length ?? 0;
  // A matching tag elsewhere could be inside a comment or after executable markup.
  if (html.startsWith(BLOCK_SCRIPTS_META, end)) return html;
  return html.slice(0, end) + BLOCK_SCRIPTS_META + html.slice(end);
}

// Clone so removing render-only policies never changes the live canvas or its selection.
export function serializeEmailPreviewDocument(doc: Document): string {
  const root = doc.documentElement.cloneNode(true) as HTMLElement;
  root
    .querySelectorAll(`meta[${PREVIEW_POLICY_ATTRIBUTE}]`)
    .forEach((meta) => meta.remove());
  return root.outerHTML;
}
